<template lang="pug">
    .parallax(ref="parallax")
        slot
</template>

<script>
    export default {
        name: "Parallax",
        computed:{
            isMobileOrTablet(){
                return this.$store.state.isMobileOrTablet;
            },
        },
        methods:{
            parallax(e) {
                let w = window.innerWidth;
                let h = window.innerHeight;

                let offsetX = 0.5 - e.screenX / w;
                let offsetY = 0.5 - e.screenY / h;

                let items = this.$refs.parallax.querySelectorAll('[data-parallax]');
                items.forEach((el) => {
                    let k = el.dataset.parallax;// коэффициент сдвига
                    el.style.transform = 'translate3d(' + offsetX * k + '%,' + offsetY * k + '%,0)'
                })
            },
        },
        mounted() {
            if (!this.isMobileOrTablet){
                document.documentElement.addEventListener('mousemove', this.parallax)
            }
        },
        beforeDestroy() {
            if (!this.isMobileOrTablet){
                document.documentElement.removeEventListener('mousemove', this.parallax);
            }
        }
    }
</script>

<style scoped>

</style>